'use strict';

/**
 * Keep a CSS custom property on the root element equal to an element's
 * height. ResizeObserver reports a size once as soon as it starts watching,
 * then again on every change, so one call both publishes and keeps in sync.
 * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 *
 * @param {Element} el - The element to measure.
 * @param {String} propertyName - The custom property to publish to.
 * @param {Function} [readHeight] - Reads the height from `el`. Defaults to `offsetHeight`.
 * @returns {ResizeObserver} The observer, so the caller can disconnect it later.
 */
function auraWatchHeight(el, propertyName, readHeight) {
  const getHeight = readHeight || ((target) => target.offsetHeight);

  const observer = new ResizeObserver(() => {
    document.documentElement.style.setProperty(propertyName, `${getHeight(el)}px`);
  });

  observer.observe(el);

  return observer;
}
